import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import LoginComponent from './login.component';
import AuthService from '../../services/auth.service';
import LoginService from '../../services/login.service';

let LoginModule = angular
  .module('Login', [
    uiRouter
  ])
  .component('login', LoginComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('login', {
      url: '/login',
      views: {
        'menu': "",
        'content': {
          component: 'login'
        }
      }
    })
  })
  .name;

export default LoginModule;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.js